import { postUserActivity } from "common/services/analytics.service";
import { useEffect } from "react";

export function usePageActivity(
  pageUrl: string,
  pageName: string,
  resourceId?: number | null | string
) {
  useEffect(() => {
    postUserActivity({
      data: {
        pageUrl: pageUrl,
        pageName: pageName,
        resourceId: resourceId || null,
      },
    }).catch(console.error);
  }, [pageUrl, pageName, resourceId]);
}
